import { gql } from '@apollo/client';

export const DELETE_CASE_FORM = gql`
    mutation deleteCaseForm($id: ID!) {
        deleteCaseForm(id: $id) {
            ok
        }
    }
`;
